module.exports = __webpack_public_path__ + "img/Diners.386ce000.svg";